module.exports = __webpack_public_path__ + "static/media/CO.714d1724.svg";